/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import axios from "axios"
import router from "@/router"
// import axiosRetry from "axios-retry"
import { getToken, logout } from "@/domain/auth/auth.service"
import { systemState } from "@/domain/system/system.state"
const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8080/api"

/*
────────────────────────────────────────
Axios Instance
────────────────────────────────────────
*/

const api = axios.create({
    baseURL: API_URL,
    timeout: 15000,
    withCredentials: false
})

/*
────────────────────────────────────────
Axios Retry
────────────────────────────────────────
*/

// axiosRetry(api, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

/*
────────────────────────────────────────
Request Interceptor
────────────────────────────────────────
*/

api.interceptors.request.use((config) => {

    const token = getToken()

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    /* Bedrock Debug */
    // config.headers["x-sdev-client"] = "bedrock-ui"
    // config.headers["x-sdev-debug"] = "true"

    /* Request ID (Tracing) */
    // config.headers["x-request-id"] = crypto.randomUUID()
    systemState.loading++
    return config

})

/*
────────────────────────────────────────
Response Interceptor
────────────────────────────────────────
*/

api.interceptors.response.use(

    (response) => {
        systemState.loading--
        return response

    },

    (error) => {
        systemState.loading--
        const status = error.response?.status

        /*
        401 → logout
        */

        if (status === 401) {

            logout()

            router.push({
                path: "/login",
                query: {
                    reason: "session-expired"
                }
            })

        }

        /*
        Network error
        */

        if (!error.response) {

            console.error("API Network Error:", error)

        }

        /*
        Server error
        */

        if (status >= 500) {

            console.error("API Server Error:", error.response)

        }

        return Promise.reject(error)

    }

)

export default api